import { render, staticRenderFns } from "./departmentDialog.vue?vue&type=template&id=5fbb3c5c&scoped=true&"
import script from "./departmentDialog.vue?vue&type=script&lang=js&"
export * from "./departmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./departmentDialog.vue?vue&type=style&index=0&id=5fbb3c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb3c5c",
  null
  
)

export default component.exports